import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Box, Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import { useNavigate } from "react-router-dom";
import DatePicker from "../../../../../../../Supporting files/DatePicker/DatePicker";
import RKTextField from "../../../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../../../Supporting files/SelectDropdown/SelectDropdown";
import "../../../../../../../formLayout.scss";
function EditPersonalDetails() {
  const navigate = useNavigate();
  const [organizationName, setOrganizationName] = React.useState("");
  const [gender, setGender] = React.useState("");
  const [Dob, setDob] = React.useState<Date | null>(null);
  const [phoneNumber, setPhoneNumber] = React.useState("");
  const [designation, setDesignation] = React.useState("");
  const [department, setDepartment] = React.useState("");
  const [mobileNumber, setMobileNumber] = React.useState("");
  const [file, setFile] = React.useState("");
  const [streetName, setStreetName] = React.useState("");
  const [areaName, setAreaName] = React.useState("");
  const [country, setCountry] = React.useState("");
  const [city, setCity] = React.useState("");
  const [zipcode, setZipcode] = React.useState("");
  const [state, setState] = React.useState("");

  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];

  const department_data = [
    { label: "Design", value: "Design" },
    { label: "Engineering", value: "Engineering" },
    { label: "Management", value: "Management" },
  ];

  const gender_data = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
  ];
  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  function handleChange(e: any) {
    console.log(e.target.files);
    setFile(URL.createObjectURL(e.target.files[0]));
  }
  return (
    <Box className="layoutWrapper">
      {/* Page header */}
      <Grid container spacing={3} className="pageHeader">
        <Grid xs={6} className="pageTitle">
          <Link
            className="backStep"
            onClick={() => {
              navigate("/SettingModuleForm?page=Modules&section=custom");
            }}
          >
            <ChevronLeftIcon />
          </Link>

          <div>
            <h3>Edit</h3>
          </div>
        </Grid>
        <Grid xs={6}></Grid>
      </Grid>

      <Grid container spacing={3}>
        <Grid xs={12}>
          <Grid container spacing={3}>
            <Grid xs className="rightSection">
              <Box className="detailSection">
                <div className="sectionTitle">
                  <h4>Personal Details</h4>
                </div>

                <Grid container spacing={3}>
                  <Grid xs={3} className="align-item-center text-center">
                    <div className="profile_section">
                      <h6 className="mb-2">Profile Picture</h6>
                      <div className="profile_inner_section">
                        <img
                          src={
                            file.length > 0
                              ? file
                              : "images/nobody_original.svg"
                          }
                          alt=""
                          className="edit_profile_logo"
                        />
                        <Link className="upload_img" component="label">
                          <input
                            hidden
                            accept="image/*"
                            multiple
                            type="file"
                            onChange={handleChange}
                          />
                          <img src="images/edit_image_icon.svg" alt="" />
                        </Link>
                      </div>
                    </div>
                  </Grid>
                  <Grid xs={9}>
                    <Grid container spacing={3}>
                      <Grid sm={4} md={4} lg={4} xl={4}>
                        <RKTextField
                          class_name="inputField"
                          title={"Name"}
                          value={organizationName}
                          attrName={setOrganizationName}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4} md={4} lg={4} xl={4}>
                        <RKTextField
                          class_name="inputField"
                          title={"Designation"}
                          value={designation}
                          attrName={setDesignation}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4} md={4} lg={4} xl={4}>
                        <SearchDropdown
                          class_name="inputField"
                          title="Department"
                          value={department}
                          attrName={setDepartment}
                          value_update={updateMasterState}
                          data={department_data}
                          error_message="Please select department"
                          warn_status={false}
                        />
                      </Grid>

                      <Grid xs={4} md={4} lg={4} xl={4}>
                        <SelectDropdown
                          class_name="inputField"
                          title="Gender"
                          value={gender}
                          attrName={setGender}
                          value_update={updateMasterState}
                          dropdown_data={gender_data}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid xs={4} md={4} lg={4} xl={4}>
                        <DatePicker
                          class_name="inputField"
                          title="Date of Birth"
                          value={Dob}
                          attrName={setDob}
                          value_update={updateMasterState}
                          error_message="Please enter Date of Birth"
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={4} xl={4}>
                        <RKTextField
                          class_name="inputField"
                          title={"Phone Number"}
                          value={phoneNumber}
                          attrName={setPhoneNumber}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                      <Grid sm={4} md={4} lg={4} xl={4}>
                        <RKTextField
                          class_name="inputField"
                          title={"Mobile Number"}
                          value={mobileNumber}
                          attrName={setMobileNumber}
                          value_update={updateMasterState}
                          warn_status={false}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                {/* Address Details */}
                <Grid container spacing={3}>
                  <Grid xs={12}>
                    <h5 className="subHeading">Address Details</h5>
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid sm={4} md={4} lg={4} xl={4}>
                    <RKTextField
                      class_name="inputField"
                      title={"Street Name"}
                      value={streetName}
                      attrName={setStreetName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={4} md={4} lg={4} xl={4}>
                    <RKTextField
                      class_name="inputField"
                      title={"Area Name"}
                      value={areaName}
                      attrName={setAreaName}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={4} md={4} lg={4} xl={4}>
                    <SearchDropdown
                      class_name="inputField"
                      title="State"
                      value={state}
                      attrName={setState}
                      value_update={updateMasterState}
                      data={state_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                  <Grid sm={4} md={4} lg={4} xl={4}>
                    <SearchDropdown
                      class_name="inputField"
                      title="City"
                      value={city}
                      attrName={setCity}
                      value_update={updateMasterState}
                      data={city_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                  <Grid sm={4} md={4} lg={4} xl={4}>
                    <RKTextField
                      class_name="inputField"
                      title={"Zipcode"}
                      value={zipcode}
                      attrName={setZipcode}
                      value_update={updateMasterState}
                      warn_status={false}
                    />
                  </Grid>
                  <Grid sm={4} md={4} lg={4} xl={4}>
                    <SearchDropdown
                      class_name="inputField"
                      title="Country"
                      value={country}
                      attrName={setCountry}
                      value_update={updateMasterState}
                      data={country_data}
                      warn_status={false}
                      error_message="Please select client"
                    />
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Grid container spacing={3} className="footerSection">
        <Grid xs={12} className="ctaBtn">
          <Button variant="contained" className="submitBtn">
            Save
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

export default EditPersonalDetails;
